// extracted by mini-css-extract-plugin
export default {"card":"convertConfirmation_card__ANIgv","wrapper":"convertConfirmation_wrapper__v5Oyg","title":"convertConfirmation_title__wsRBW","paragraph":"convertConfirmation_paragraph__gWtPL"};